import { render } from "./component-limits.vue?vue&type=template&id=44a5e992&ts=true"
import script from "./component-limits.vue?vue&type=script&lang=ts"
export * from "./component-limits.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__